"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.slice.js");
var _default = exports.default = {
  methods: {
    /** 节点被点击时的回调
     * @description: 共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身。
     * @param { Object } data 树节点数据对象
     * @param { Object<Node> } Node 被点击节点 Node
     * @param { Object<VueComponent> } treeNode 被点击节点 组件对象
     * @return { void }
     */
    treeNodeClick: function treeNodeClick() {
      this.$$listenersEmit.apply(this, ['node-click'].concat(Array.prototype.slice.call(arguments)));
      this.$$listenersEmit.apply(this, ['tree-node-click'].concat(Array.prototype.slice.call(arguments)));
    },
    /** 表格排序事件
     * @description: 表格排序发生改变时触发
     * @param { Object } column 按钮对象
     * @param { Object } prop 点击事件对象
     * @param { Object } order 点击事件对象
     * @return { void }
     */
    tableSortChange: function tableSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      Object.assign(this.tableSort, {
        sortOrder: order === 'ascending' ? 'asc' : 'desc',
        sortColumn: prop
      });
      this.getDatas();
      this.$$listenersEmit.apply(this, ['sort-change'].concat(Array.prototype.slice.call(arguments)));
    }
  }
};